import React from 'react';
import { Alert, Button } from '@mui/material';
import { useAuth0 } from 'src/applicationproviders';

/**
 * Persistent red bar that renders above every authenticated screen when the current session
 * is an impersonation. The operator should never be in doubt about whether they are
 * impersonating, and should always have a one-click exit.
 */
export const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedUser, exitImpersonation } = useAuth0();

  if (!isImpersonating) return null;

  const label = impersonatedUser?.email ?? '(unknown user)';

  return (
    <Alert
      severity='error'
      icon={false}
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2000,
        borderRadius: 0,
        backgroundColor: '#b71c1c',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 600,
        '& .MuiAlert-message': {
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          width: '100%',
          justifyContent: 'center',
        },
      }}
    >
      <span>IMPERSONATING {label}</span>
      <Button
        variant='outlined'
        size='small'
        onClick={exitImpersonation}
        sx={{
          color: '#fff',
          borderColor: '#fff',
          '&:hover': {
            borderColor: '#fff',
            backgroundColor: 'rgba(255,255,255,0.1)',
          },
        }}
      >
        Exit
      </Button>
    </Alert>
  );
};

export default ImpersonationBanner;
